
import { useRef, useEffect } from "react";

/**
 * Хук возвращает true только один раз,
 * когда condition впервые становится true.
 * После этого состояние «замораживается».
 */
export function useInitialTrigger(condition: boolean): boolean {
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (condition && !triggeredRef.current) {
      triggeredRef.current = true;
    }
  }, [condition]);

  return triggeredRef.current;
}
